import ko from 'knockout';
import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import { adGroupTypeEnum } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';

export default class {
  constructor({
    availableExtensions = [],
    adExtensionsDynamicFeatures,
    adExtensionsStaticFeatures,
  } = {}) {
    koSchema.properties(this);

    this.adGroups = ko.observableArray([]);

    this.adExtensionDynamicFeatures = {};
    this.adExtensionStaticFeatures = {};
    _.each(availableExtensions, (type) => {
      this[type] = ko.observableArray([]);
      if (adExtensionsDynamicFeatures) {
        // Resolving dynamic features here in view-model,
        // so the template and Knockout bindings don't have to
        this.adExtensionDynamicFeatures[type] = adExtensionsDynamicFeatures(type);
      }
      if (adExtensionsStaticFeatures) {
        // Resolving static features here in view-model,
        // so the template and Knockout bindings don't have to
        this.adExtensionStaticFeatures[type] = adExtensionsStaticFeatures[type];
      }
    }, this);

    this.dynamicAdGroups = ko.computed(() => {
      return _.filter(this.adGroups(), (adGroup) => adGroup.AdGroupType === adGroupTypeEnum.SearchDynamic);
    });
    this.standardAdGroups = ko.computed(() => {
      return _.filter(this.adGroups(), (adGroup) => adGroup.AdGroupType === adGroupTypeEnum.SearchStandard);
    });

    this.isDynamicSectionExpanded = ko.observable(true);
    this.isStandardSectionExpanded = ko.observable(true);

    this.isAdExtensionExpanded = ko.observable(true);

    this.hasChanges = ko.observable(false);
  }
}
